import "./style.scss";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionBuilder as AB } from "@common/build/types";
import { closePopup } from "@builder/store/slices/popupSlice";
import { ActionBuilderType, transformToActionBuilder, validateData } from "@builder/utils/actionBuilderHelpers";
import { updateActionBuilder, updateBuildActions, updateNodeActions } from "@builder/store/slices/BuilderSlice/builderSlice";
import PopupHeader from "@builder/components/app/Popup/PopupHeader";
import Button from "@builder/components/general/Button";
import ActionMenu from "@builder/components/app/ActionBuilder";
import { useTranslation } from "react-i18next";
import OliverText from "@builder/components/general/OliverText";
import { clearActionsEditor } from "@builder/store/slices/actionBuilderSlice";

const ActionBuilder = () => {
    const dispatch = useAppDispatch();
    const actionName = useAppSelector(state => state.actionBuilder.actionsEditor[0].name);
    const allActions = useAppSelector(state => state.actionBuilder.actionsEditor);
    const count = useAppSelector(state => state.builder.build.actionBuilder);
    const isAutomation = useAppSelector(state => state.popup.isAutomation);
    const actionPath = useAppSelector(state => state.popup.actionPath);
    const { t } = useTranslation();

    const handleSaveAction = () => {
        const startAction = allActions.find(item => item.type === ActionBuilderType.START);
        const otherActions = allActions
            .filter(item => item.type !== ActionBuilderType.START && item.type !== ActionBuilderType.NEW)
            .map(item => transformToActionBuilder(item));

        if (!startAction) return;

        for (const item of otherActions) {
            if (!item.action || !validateData(item.action, item.action.type)) {
                return;
            }
        }

        const actionBuilder: AB = {
            name: startAction.name || `Action #${Object.keys(count || {}).length + 1}`,
            id: startAction.id || "",
            trigger: startAction.action?.condition ? { condition: startAction.action.condition } : null,
            isAuto: startAction.isAuto || false,
            actions: [...otherActions]
        };
        dispatch(updateActionBuilder(actionBuilder));
        if (!isAutomation) {
            dispatch(updateNodeActions({ actionId: actionBuilder.id, actionPath }));
            dispatch(closePopup());
        } else {
            dispatch(updateBuildActions(actionBuilder.id));
            dispatch(closePopup());
            // dispatch(setCurrentPopup("actions"));
        }

        dispatch(clearActionsEditor());
    };

    const headerSubtext = (
        <div className="action-header-subtitle-wrapper">
            <OliverText
                text={isAutomation ? t("popup.popupHeader.Auto-triggered action") : t("popup.popupHeader.Manually-triggered action")}
                size="s"
                color="base-grey"
            />
        </div>
    );

    return (
        <div className="actions">
            <PopupHeader
                src="/actions-icon.svg"
                title={actionName || "New Action"}
                subtext={headerSubtext}
                customOnClose={() => dispatch(closePopup())}
                noTranslateTitle={!!actionName}
                noTranslateSub
            >
                <Button buttonStyle="primary" text="Save action" size="small" className="actions-header-button" onClick={handleSaveAction} />
            </PopupHeader>
            <div className="actions-body">
                <ActionMenu />
            </div>
        </div>
    );
};

export default ActionBuilder;
